import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import styled from "@emotion/styled";

const ToutCheckMark = styled(FaCheck)({
  color: "#667cce",
  marginRight: "12px",
});

export { ToutCheckMark };
